import { BuilderTypes } from "@/api/AppApi/common-interfaces/api-enums";
import { CompanyFilterTypes } from "../../company/interfaces/ICompany";

export enum ProductTabStyleTypes {
  inline = "inline", //(default)
  button = "button",
}
export interface IProductTab {
  filter: CompanyFilterTypes;
  title: string;
}
export interface IProductTabs {
  index: number;
  type: BuilderTypes.product_tabs;
  configurations: {
    title: string;
    number_of_products: number;
    show_categories: boolean;
    enable_pagination: boolean;
    style_type: ProductTabStyleTypes;
  };
  data: IProductTab[];
}
